const tableCellEquip = {
  cellHaveChecklist: 'Yes',
  cellNotHaveChecklist: 'No',
}

export default tableCellEquip;